module.exports = __tmimport("widgets/vault/remote");